<!-- 配件销售历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn" style="min-height: 0;margin-top:10px;">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">汽配编码</div>
                    <el-input class="search-item" size="small" v-model="searchData.APCode" placeholder="请输入汽配编码"></el-input>
                    <div class="search-name">汽配名称</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.GoodName" placeholder="请输入汽配名称"></el-input>
                    <div class="search-name">适用车型</div>
                    <el-input class="search-item" size="small" v-model.trim="searchData.AutoSerise" placeholder="适用车型"></el-input>
                    <div class="search-name">时间区间</div>
                    <el-date-picker
                        v-model="dateTimes"
                        type="daterange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        @change="handleChange"
                        size="small"
                        class="search-name"
                    ></el-date-picker>
                </div>
            </div>
        </div>
        <div class="search-ctn" style="min-height: 0">
            <div class="search-ctn-left">
                <div class="flex">
                    <div class="search-name">品牌</div>
                    <div class="search-item goods-categories">
                        <el-select
                            v-model="searchData.BrandName"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            size="small"
                            style="width: 100%"
                            @visible-change="brandVisibleChange($event)"
                        >
                            <el-option :key="item.Text" v-for="item in brandList" :label="item.Text" :value="item.Text"></el-option>
                        </el-select>
                    </div>
                    <div class="search-name">汽配分类</div>
                    <div class="search-item goods-categories">
                        <el-select
                            size="small"
                            style="width: 100%"
                            v-model="searchData.APCate"
                            multiple
                            collapse-tags
                            filterable
                            clearable
                            remote
                            :remote-method="searchGoodsType"
                            v-select-scroll-more="searchGoodsTypeLoad"
                            @visible-change="cateVisibleChange($event)"
                        >
                            <el-option v-for="optionItem in typeList" :key="optionItem.Value" :label="optionItem.Text" :value="optionItem.Value">
                                <div class="option-content">
                                    <div>{{ optionItem.Text }}</div>
                                </div>
                            </el-option>
                        </el-select>
                    </div>
                    <div class="search-name">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button class="search-btn btn-primary" size="small" @click="chooseAPs()">确定 (选中{{ selection.length }}项)</el-button>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-ctn">
            <el-table
                :header-cell-style="{ background: '#F2F6FC' }"
                :data="tableData"
                border
                style="width: 100%; margin-bottom: 0px"
                @selection-change="onColumnSelect"
                :row-key="getRowKeys"
                @row-click="rowClick"
            >
                <el-table-column type="selection" width="55" reserve-selection></el-table-column>
                <!-- <el-table-column
          width="170px"
          prop="OrderCode"
          label="订单号"
          show-overflow-tooltip
        ></el-table-column> -->
                <el-table-column width="160px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="GoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="AutoSerise" label="适用车型" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="IsShowBrand" prop="Brand" width="80px"  label="品牌" show-overflow-tooltip></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="ReturnCount" label="数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="WarehousedCount" label="已出仓数"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="AlReturnCount" label="已退数量"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" label="可退数量">
                    <template slot-scope="scope">
                        {{ scope.row.WarehousedCount - scope.row.AlReturnCount }}
                    </template></el-table-column
                >
                <el-table-column show-overflow-tooltip width="80px" prop="Unit" label="单位"></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="SalePrice" label="售价"></el-table-column>
                <!-- <el-table-column
          show-overflow-tooltip
          width="160px"
          prop="CreateTime"
          label="下单时间"
        ></el-table-column> -->
                <!-- <el-table-column fixed="right" label="销售明细" width="100">
          <template slot-scope="scope">
              <img
                src="@/assets/images/cus.png"
                style="width: 26px; height: 26px; margin-left: 4px"
                title="销售历史"
                @click="showSaleStat(scope.row)"
              />
          </template>
        </el-table-column> -->
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
        <!-- 销售历史 -->
        <el-dialog
            :title="SaleDialogTitle"
            :close-on-click-modal="false"
            :visible.sync="eyeHistoryVisible"
            append-to-body
            v-dialog-drag
            lock-scroll
            :modal="false"
            id="change-dialog"
            style="margin-left: -500px"
        >
            <div v-if="eyeHistoryVisible">
                <APHistory
                    ref="APHistory"
                    :showCusColumn="false"
                    :EntpCusId="EntpCusId"
                    :EntpTempGoodsId="hisGoodsId"
                    :EntpCusName="EntpCusName"
                    :NoInit="true"
                    @closeDialog="eyeHistoryVisible = false"
                ></APHistory>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import APHistory from '@/components/common/APHistory';
export default {
    name: '',
    props: {
        EntpCusId: {
            type: String
        },
        EntpCusName: {
            type: String
        },
        IsShowBrand:{
            type: Boolean
        }        
    },
    components: { APHistory },
    data() {
        return {
            loading: false,
            selLoading: false,
            eyeHistoryVisible: false,
            SaleDialogTitle: '',
            hisGoodsId: '',
            typeList: [],
            brandList: [],
            customerList: [],
            searchData: {
                EntpCusId: this.EntpCusId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            },
            statData: [],
            tableData: [],
            tableDataLength: 0,
            avg: 0,
            month: 0,
            year: 0,
            selection: [],
            dateTimes: [new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 90), new Date()],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近半年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一年',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            }
        };
    },
    mounted() {
        this.searchData.StartDate = this.$util.formatDate(this.dateTimes[0]);
        this.searchData.EndDate = this.dateTimes[1];
        if (this.EntpCusId) this.searchData.EntpCusId = this.EntpCusId;
        else this.$.$util.warningMsg('客户信息异常，请刷新后重试');
        this.getTableData();
    },
    methods: {
        rowClick(row) {
            this.showSaleStat(row);
        },
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.EntpCusId && !that.searchData.EntpCusId) {
                    if (that.customerList.length == 1) that.searchCustomer();
                } else {
                    if (that.customerList.length == 0) that.searchCustomer();
                }
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            this.selLoading = true;
            this.$util
                .searchCustomer(key)
                .then(data => {
                    this.customerList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                EntpCusId: this.EntpCusId,
                APCode: '',
                GoodName: '',
                AutoSerise: '',
                BrandName: [],
                APCate: [],
                Page: 1,
                Limit: 10,
                StartDate: '',
                EndDate: ''
            };
            this.dateTimes = [];
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 更新表格数据
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getTableData() {
            this.loading = true;
            this.$util
                .axiosPost({
                    url: '/api/EntpSaleOrder/GetGoodsSaleHistoriesForReturn',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        handleChange(val) {
            if (val) {
                this.searchData.StartDate = val[0];
                this.searchData.EndDate = val[1];
            } else {
                this.searchData.StartDate = '';
                this.searchData.EndDate = '';
            }
        },
        onColumnSelect(val) {
            this.selection = val;
        },
        //多选配件
        chooseAPs() {
            let items = this.selection;
            this.$emit('closeDialog', items);
        },
        getRowKeys(row) {
            return row.EntpTempGoodsId;
        },
        searchGoodsTypeLoad() {
            this.typeForm.Page += 1;
            this.searchGoodsType();
        },
        showSaleStat(row) {
            let that = this;
            if (row) {
                that.SaleDialogTitle = '销售数据：' + row.APCode + ' ' + row.GoodsName + ' ' + row.AutoSerise;
                that.hisGoodsId = row.EntpTempGoodsId;
                if (!that.eyeHistoryVisible) that.eyeHistoryVisible = true;
                that.$nextTick(() => {
                    that.$refs.APHistory.updateTableData(row.EntpTempGoodsId);
                });
            }
        }
    }
};
</script>
<style lang="less">
#change-dialog {
    position: absolute;
    top: 0;
    left: 50%;
    right: auto;
    bottom: auto;
    width: 10px;
    height: 10px;
    overflow: visible;
    .el-dialog {
        width: 1000px;
        // height: 500px;
        box-shadow: 0 0 9px 3px #999;
    }
    .add-row-dialog {
        width: 340px;
        height: auto;
        .form-div {
            margin-top: 20px;
        }
        .dialog-footer {
            text-align: right;
        }
    }
    .el-dialog__body {
        height: calc(100% - 54px);
        overflow: auto;
    }
}
</style>
